import { useMutation } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { MutationOptions, queryClient } from '@/api/react-query'
import { customerApplicationsQueryKey } from '@/api/financial/customer/list-customer-applications'

async function cancelApplication(applicationKey: string) {
  await httpClient('financial').post(`/v1/application/${applicationKey}/cancel`)
}

function invalidateCreditQueries() {
  queryClient.invalidateQueries({ queryKey: ['customer-context', 'financial'] })
  queryClient.invalidateQueries({ queryKey: customerApplicationsQueryKey })
}

export function useCancelApplication(options?: MutationOptions<void, string>) {
  const { onSuccess, ...rest } = options ?? {}

  return useMutation({
    mutationFn: cancelApplication,
    ...rest,
    onSuccess: (...args) => {
      invalidateCreditQueries()
      onSuccess?.(...args)
    },
  })
}
